import React from 'react';
import styles from './PlanTermsStep.module.css';

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={styles.featureTileCheck}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

const PlanCard = ({ onStartTrial, isProcessing, children }) => {
  return (
    <div className={styles.mainPanelCard}>
      <div className={styles.planCardHeader}>
        <h2 className={styles.panelTitle}>Plan & Terms</h2>
        <p className={styles.panelSubtitle}>Choose your plan and review our terms of service.</p>
      </div>

      <div className={styles.planCardBlock}>
        <div className={styles.planNamePrice}>
          Hooptie Elite <span>7 Day Free Trial</span>
        </div>
        <div className={styles.planTrialSubline}>
          <CheckIcon /> Then $249/month. Cancel anytime before day 7.
        </div>
        <p className={styles.planNoChargeToday}>No charge today.</p>
        <button
          type="button"
          className={styles.ctaButton}
          onClick={onStartTrial}
          disabled={isProcessing}
        >
          {isProcessing ? 'Starting…' : 'Continue'}
        </button>
        <p className={styles.ctaMicrocopy}>No contract. Cancel anytime.</p>
      </div>

      {children}
    </div>
  );
};

export default PlanCard;
